module.exports = __webpack_public_path__ + "static/khaled-chafaa-9eb34e4a26a644e556eb75288bd37e7a.jpg";